/**
 * Additional typing for the Emscripten generated code.
 */

import type {
  ClassHandle,
  DrawingWrapper,
  Frontend,
  MainModule,
  NotifyGameIdChange,
  NotifyGameStateChange,
  NotifyParamsChange,
  NotifyStatusBarChange,
  Point,
  Size,
} from "../assets/puzzles/emcc-runtime";

// (Re-export generated types so other code doesn't need to dig into assets.)
export type {
  Colour,
  Drawing,
  DrawingWrapper,
  DrawTextOptions,
  Frontend,
  FrontendConstructorArgs,
  KeyLabel,
  NotifyGameIdChange,
  NotifyGameStateChange,
  NotifyParamsChange,
  NotifyStatusBarChange,
  Point,
  PresetMenuEntry,
  Rect,
  Size,
} from "../assets/puzzles/emcc-runtime";

export type PuzzleId = string;
export type EncodedParams = string;

export type ConfigDescription = ReturnType<Frontend["getPreferencesConfig"]>;
export type ConfigItem = ReturnType<Frontend["getPreferencesConfig"]>["items"]["any"];
export type ConfigValues = ReturnType<Frontend["getPreferences"]>;

export type ChangeNotification =
  | NotifyGameIdChange
  | NotifyGameStateChange
  | NotifyParamsChange
  | NotifyStatusBarChange;

export type GameStatus = NotifyGameStateChange["status"];

export enum PuzzleButton {
  LEFT_BUTTON = 0x0200,
  MIDDLE_BUTTON,
  RIGHT_BUTTON,
  LEFT_DRAG,
  MIDDLE_DRAG,
  RIGHT_DRAG,
  LEFT_RELEASE,
  MIDDLE_RELEASE,
  RIGHT_RELEASE,
  CURSOR_UP,
  CURSOR_DOWN,
  CURSOR_LEFT,
  CURSOR_RIGHT,
  CURSOR_SELECT,
  CURSOR_SELECT2,
  /* UI_* are special keystrokes generated by front ends in response
   * to menu actions, never passed to back ends */
  UI_LOWER_BOUND,
  UI_QUIT,
  UI_NEWGAME,
  UI_SOLVE,
  UI_UNDO,
  UI_REDO,
  UI_UPPER_BOUND,

  /* made smaller because of 'limited range of datatype' errors. */
  MOD_STYLUS = 0x0800,
  MOD_CTRL = 0x1000,
  MOD_SHFT = 0x2000,
  MOD_NUM_KEYPAD = 0x4000,
  MOD_MASK = 0x7800 /* mask for all modifiers */,
}

export interface PuzzleStaticAttributes {
  displayName: string;
  canConfigure: boolean;
  canSolve: boolean;
  // TODO: canFormatAsTextEver: boolean;
  needsRightButton: boolean;
  isTimed: boolean;
  wantsStatusbar: boolean;
}

/**
 * Required JS-side implementation for Drawing API
 */
export interface DrawingImpl<Blitter = unknown>
  extends Omit<DrawingWrapper, keyof ClassHandle | "notifyOnDestruction">,
    Partial<Pick<DrawingWrapper, "notifyOnDestruction">> {
  // Redeclare blitter methods to improve typing
  blitterNew(size: Size): Blitter;
  blitterFree(blitter: Blitter): void;
  blitterSave(blitter: Blitter, origin: Point): void;
  blitterLoad(blitter: Blitter, origin?: Point): void;
}

/**
 * The Emscripten generated module object
 */
export interface PuzzleModule extends MainModule {
  // Replace `any` args for Drawing.implement()
  Drawing: {
    implement(drawing: DrawingImpl): DrawingWrapper;
    extend: MainModule["Drawing"]["extend"];
  };
}

/**
 * Drawing font selection
 */
export interface FontInfo {
  fontFamily: string;
  fontWeight: string;
  fontStyle: string;
}
